const FormHelper = {
  getEditorMentions() {
    return Array.from(
      document.querySelectorAll('.ProseMirror [data-mention-id]')
    ).map(mention => mention.dataset.mentionId)
  },
  validate(inputs) {
    let valid = true
    for (let input of inputs) {
      if (input && !input.validateData()) {
        valid = false
      }
    }
    return valid
  },
  commaSeparatedToArray(data) {
    return data
      .split(',')
      .map(word => word.trim())
      .filter(word => word) // remove falsy elements
  },
  reset(inputs) {
    inputs.forEach(input => input.reset())
  },
  clearErrors(inputs) {
    inputs.forEach(input => input.clearErrors())
  }
}

export default FormHelper
